import { Button, ButtonProps, useNotify, useRecordContext } from "react-admin";
import {client} from "../../dataProvider";
import {generateError} from "../../shared/utils";
import { CgDanger } from "react-icons/cg";
import {getUser} from "../../authProvider";

export const
    ResetXmlButton = (
        props: ButtonProps & { onSuccess: () => void }
    ) => {
        const user = getUser();
        const { onSuccess, ...rest } = props;
        const record = useRecordContext();
        const notify = useNotify();

        const handleSubmit = async (e: any) => {
            e.stopPropagation();
            const r = window.confirm(
                "Ripristinare XML e stato ed eliminare le scadenze non ancora gestite? " +
                "Potrai correggere le condizioni di pagamento e ricreare le scadenze generando nuovamente l'XML."
            );
            if (r) {
                try {
                    await client(
                        `invoices/${record.id}/reset_xml_invoice`,
                        {
                            method: "GET",
                        }
                    );
                } catch (err) {
                    generateError(err, notify);
                    return;
                }
                onSuccess();
            }
        };

        return (
            user && user?.is_admin === true && record && record.status === "C" ?
            <Button {...rest} label="Ripristina xml e stato" onClick={handleSubmit}>
                <CgDanger color="danger" />
            </Button> : null
        );
    };
